import { render, staticRenderFns } from "./buyDialog.vue?vue&type=template&id=cb65d2b2&scoped=true&"
import script from "./buyDialog.vue?vue&type=script&lang=js&"
export * from "./buyDialog.vue?vue&type=script&lang=js&"
import style0 from "./buyDialog.vue?vue&type=style&index=0&id=cb65d2b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb65d2b2",
  null
  
)

export default component.exports